import { Component, OnInit } from '@angular/core';
import { TslDialogRef } from '@tesla/ng-tds';

@Component({
  selector: 'app-bank-otp-confirmation',
  templateUrl: './bank-otp-confirmation.component.html',
  styleUrls: ['./bank-otp-confirmation.component.scss']
})
export class BankOtpConfirmationComponent implements OnInit {

  constructor(
    public dialogRef: TslDialogRef<BankOtpConfirmationComponent>,
  ) { }

  ngOnInit() {
  }

  closDialog(accept: boolean) {
    this.dialogRef.close(accept);
  }

}
